import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export const enum CreateAccountStep {
    First = 1,
    Second = 2,
    Third = 3,
    Complete = 4,
}

export const enum PlaceOrderStep {
    SelectProduct = 1,
    SelectQuantity = 2,
    SelectAddress = 3,
    SelectPriceAndDeliveryOptions = 4,
    ReviewOrder = 5, // Delivery instructions?
    ConfirmationState = 6,
    Payment = 7,
    Terminal = 8
}

export const enum GetQuoteStep {
    BasicDetails = 1,
    Quotation = 2,
    Complete = 3,
}

export const enum AffinityProduct {
    Regular = 1,
    Premium = 2
}

export const enum AffinityDelivery {
    Cheapest = 1,
    Fastest = 2
}

export interface ProductModelX extends ProductModel {
    multipleSaleQty: number | undefined;
}

export type ProductViewModel = {
    id: string, // Required for call back to next step
    name: string,
    lastOrderedDate: string, // MM/DD/YYYY 
    rdcoDeclarationTypeName: string
}

export type LastPurchased = {
    id: string,
    lastOrderedDate: Date,
}

export type QuantityViewModel = {
    product: string
    minimum: number;
    maximum: number;
    increment: number;
}

export type AddressViewModel = {
    id: string,
    companyName: string,
    address: string,
}

export type PriceOptionViewModel = {
    id: string,
    quantity: number,
    deliveryBy: Date,
    netUnitPrice: number,
    netCost: number,
}

export type ProductPriceParameter = {
    productId: string;
    unitOfMeasure: string;
    qtyOrdered: number;
    Properties: {
        Address: string;
    }
}

export type ProductPriceParameters = {
    productPriceParameters: ProductPriceParameter[];
}

export type HarrierSourceModel = {
    quantity: number,
    deliveryBy: Date,
    netCost: number,
    netUnitPrice: number,
    priceId: number,
    supplierId: number,
}

export type HarrierPricingItemModel = {
    harrierSource: HarrierSourceModel,
    upliftRate: number,
    vatRate: number,
    unitPrice: number,
    unitPriceWithUplift: number,
    unitPriceWithUpliftAndVAT: number,
    total: number,
    totalWithUplift: number,
    totalWithUpliftAndVAT: number,
}

export type HarrierPricingModel = {
    items: HarrierPricingItemModel[];
}